import React from "react";
import { useSidebar } from "./SidebarContext";

const Apps = ({profile,isSuperAdim}) => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("UserId");
  const { openApps, setOpenApps} = useSidebar();
  console.log("t",isSuperAdim,profile);
  

  const links = [
    {
      name: "Sequential Startup",
      url: `https://sequential-startup.avatare.com/auth?token=${token}&userId=${userId}`,
      logo: "/sq.svg",
    },
    {
      name: "Conversational AI",
      url: `https://conversational.avatare.com/auth?token=${token}&userId=${userId}`,
      logo: "/av.svg",
    },
    { name: "AI ToolKit", url: null, logo: "/av.svg" },
    { name: "AI Agents", url: null, logo: "/av.svg" },
    { name: "ThinkLinkAI", url: null, logo: "/av.svg" },
  ];  

  const filteredProducts = isSuperAdim
  ? links
  : links.filter((product) =>
      profile?.modules
        ?.map((m) => m.toLowerCase())
        .includes(product.name.toLowerCase())
    );


  return (
    <div className="fixed inset-0 w-screen h-screen z-[100000] bg-[#00000030] transition-opacity duration-300 ease-out">
    <div
      className={`
        overflow-y-auto bg-white w-full lg:w-2/5 h-screen pt-6 px-[30px]
        transform transition-transform duration-300 ease-out
        ${openApps ? "translate-x-0 opacity-100" : "translate-x-full opacity-0 pointer-events-none"}
      `}
    >
        <div className="flex justify-between items-center pb-12  cursor-pointer">
            <p className="text-[20px] font-normal">
                Products
            </p>
          <div onClick={() => setOpenApps(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M12 4L4 12"
                stroke="#0A0A0A"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 4L12 12"
                stroke="#0A0A0A"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-[25px]">
          {filteredProducts.map((v, i) =>
            v.url ? (
              <a
                key={i}
                href={v.url}
                target="_blank"
                rel="noopener noreferrer"
                className="border-[#E5E5E5] border-[1px] rounded-[8px] flex flex-col justify-center items-center p-3 gap-2"
                style={{
                  boxShadow:
                    "0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px -4px rgba(0, 0, 0, 0.10)",
                }}
              >
                <img
                  src={v.logo}
                  alt={v.name}
                  className="w-[140px] h-auto mx-auto"
                />
                <p className="font-normal text-xs text-center">{v.name}</p>
              </a>
            ) : (
              <div
                key={i}
                className="border-[#E5E5E5] border-[1px] rounded-[8px] flex flex-col justify-center items-center p-3 gap-2 opacity-50 cursor-not-allowed"
                style={{
                  boxShadow:
                    "0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px -4px rgba(0, 0, 0, 0.10)",
                }}
              >
                <img
                  src={v.logo}
                  alt={v.name}
                  className="w-[140px] h-auto mx-auto"
                />
                <p className="font-normal text-xs text-center">{v.name}</p>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Apps;
